/* Copyright (c) 2023 Xperi. All Rights Reserved. */

import React, { FunctionComponent } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/root.reducers';
import { Caret } from '../../common';
import { InteractiveComponents } from '../../../core/enums/InteractiveComponents';

import './LiveTvActionStripInteractiveLayer.scss';

const LiveTvActionStripInteractiveLayer: FunctionComponent = (): JSX.Element => {
    const actionsStripHighlightIndex = useSelector(
        (state: RootState) => state.infoBanner.actionsStripHighlightIndex,
    );

    const activeComponent = useSelector(
        (state: RootState) => state.interactiveLayer.activeComponent,
    );

    const actionsItemLength = useSelector((state: RootState) => state.infoBanner.actionItemsCount);
    return (
        <React.Fragment>
            <Caret
                direction={InteractiveComponents.WEST}
                className="actionbar-west"
                active={activeComponent === InteractiveComponents.WEST}
                visible={actionsStripHighlightIndex}
            />

            <Caret
                direction={InteractiveComponents.EAST}
                className="actionbar-east"
                active={activeComponent === InteractiveComponents.EAST}
                visible={
                    actionsItemLength > 1 && actionsItemLength !== actionsStripHighlightIndex + 1
                }
            />
        </React.Fragment>
    );
};

export default LiveTvActionStripInteractiveLayer;
